import Upgrade from './Upgrade.vue';
import { createApp } from "vue";

frappe.ready(function() {
	var central_subscription = createApp(Upgrade);
	central_subscription.mount('#upgrade');
});